import React from 'react'
import { 
    LoadMore, Cell, CellBody, CellFooter, CellHeader, Badge
} from 'react-weui'
import { getHumanTime } from '../../utils'
import { toInfoPage } from '../../services'
import { WKVisible } from '../../components/wk'
import {NoneItem} from '../../components/details'


class My extends React.Component {
    handleClickItem (item) {
        toInfoPage(item.liveroom_id)
    }
    renderMyItem (item) {
        return (
            <Cell onClick={() => this.handleClickItem(item)} key={item.latest_message.create_time} href="javascript:;" access>
                <CellHeader>
                    <div className="avatar">
                        <img src={item.avatar} />
                    </div>
                </CellHeader>
                <CellBody className='text-ellipsis'>
                    <p className='big-font nickname text-ellipsis'>{item.nickname}</p>
                    <p className='text-minor text-ellipsis msg-text'>{item.latest_message.content}</p>
                </CellBody>
                <CellFooter>
                    <p className='my-time'>{getHumanTime(item.latest_message.create_time)}</p>
                    <WKVisible create={item.unread_count > 0}>
                        <Badge preset='footer'>{item.unread_count}</Badge>
                    </WKVisible>
                </CellFooter>
            </Cell>
        )
    }
    renderMyMsgs (msgs) {
        const unreadMsgs = []
        const normalMsgs = []
        msgs.forEach(item => {
            if (item.unread_count > 0) {
                unreadMsgs.push(item)
            } else {
                normalMsgs.push(item)
            }
        })
        return unreadMsgs.concat(normalMsgs).map(item => this.renderMyItem(item))
    }
    render() {
        if (this.props.tabId != 2) return null
        if (!this.props.myMsgs) return <LoadMore loading></LoadMore>
        if(this.props.myMsgs.length === 0) return (
            <div style={{width: '100%', height: '100vh', position: 'relative'}}>
                <NoneItem
                    img="https://static-1253442168.image.myqcloud.com/picture/5915685_2b0452b9e0f084e290705183b06dd05d.jpg"
                    text="此处暂无消息哦"
                />
            </div>
        )
        return (
            <div className="my">
                {
                    this.renderMyMsgs(this.props.myMsgs)
                }
            </div>
        )
    }
}

export default My


// WEBPACK FOOTER //
// ./src/components/message/My.js